import React, { useEffect, useState, useCallback } from 'react';
import { cameraApi, systemApi } from '../../services/api';
import StreamPlayer from '../../components/StreamPlayer';
import PTZControl from '../../components/PTZControl';
import EventLog from '../../components/EventLog';
import { useWebSocket } from '../../hooks/useWebSocket';
import './Dashboard.css';

export default function Dashboard() {
  const [cameras, setCameras] = useState<any[]>([]);
  const [status, setStatus] = useState<any>(null);
  const [motionCams, setMotionCams] = useState<Set<number>>(new Set());

  useEffect(() => {
    cameraApi.list().then(({ data }) => setCameras(data.results || data));
    systemApi.status().then(({ data }) => setStatus(data)).catch(() => {});
  }, []);

  const handleWs = useCallback((msg: any) => {
    if (msg.type === 'system_update') setStatus(msg.payload);
    if (msg.type === 'new_event' && msg.event.event_type === 'motion') {
      const id = msg.event.camera;
      setMotionCams(p => new Set(p).add(id));
      setTimeout(() => setMotionCams(p => { const s = new Set(p); s.delete(id); return s; }), 15000);
    }
  }, []);
  useWebSocket(handleWs);

  const cls = (v: number, w: number, b: number) => v >= b ? 'bad' : v >= w ? 'warn' : 'ok';

  return (
    <div className="db-page">
      <div className="db-stats">
        <div className="db-stat"><span className="db-sl">KAMERA</span><span className="db-sv ok">{cameras.filter(c=>c.is_active).length}/{cameras.length}</span></div>
        {status && <>
          <div className="db-stat"><span className="db-sl">CPU</span><span className={`db-sv ${cls(status.cpu_temp,55,70)}`}>{status.cpu_temp}°C</span></div>
          <div className="db-stat"><span className="db-sl">YÜK</span><span className={`db-sv ${cls(status.cpu_load,65,85)}`}>{status.cpu_load}%</span></div>
          <div className="db-stat"><span className="db-sl">BATAREYA</span><span className={`db-sv ${cls(100-status.battery_percent,60,80)}`}>{status.battery_charging?'⚡':'🔋'} {status.battery_percent}%</span></div>
          <div className="db-stat"><span className="db-sl">SİQNAL</span><span className="db-sv ok">{status.signal_strength}%</span></div>
        </>}
      </div>
      <div className="db-grid">
        <div className="db-left">
          {cameras.map(cam => (
            <div key={cam.id} className="db-cam">
              <StreamPlayer streamUrl={cam.stream_url} cameraName={`${cam.name} — ${cam.location}`} isAlert={motionCams.has(cam.id)} />
              {cam.has_ptz && <PTZControl cameraId={cam.id} />}
            </div>
          ))}
          {!cameras.length && <div className="db-empty">Kamera tapılmadı</div>}
        </div>
        <div className="db-right"><EventLog /></div>
      </div>
    </div>
  );
}
